import { z } from "zod";

export const carrierSchema = z.object({
  carrierName: z.string(),
  bridgePayerId: z.string(),
  requiresMemberId: z.boolean(),
});

export type CarrierValue = z.infer<typeof carrierSchema>;

export const EMPTY_CARRIER: CarrierValue = {
  carrierName: "",
  bridgePayerId: "",
  requiresMemberId: true,
};

export const carrierMemberIdRefinement = (
  data: { carrier: CarrierValue; memberId: string; groupNumber: string },
  ctx: z.RefinementCtx,
) => {
  if (!data.carrier.bridgePayerId || data.carrier.requiresMemberId === false) {
    return;
  }
  if (!data.memberId) {
    ctx.addIssue({
      code: "custom",
      path: ["memberId"],
      message: "Member ID is required",
    });
  }
  if (!data.groupNumber) {
    ctx.addIssue({
      code: "custom",
      path: ["groupNumber"],
      message: "Group number is required",
    });
  }
};
